import { createContext, type FC, type ReactNode, useContext } from "react";

type PostBroadcastContextValue = {
	broadcastId: string | null;
	broadcastUserId: string | null;
	fixtureId: number | null;
	homeTeam: string;
	awayTeam: string;
	homeLogo: string;
	awayLogo: string;
};

const defaultValue: PostBroadcastContextValue = {
	broadcastId: null,
	broadcastUserId: null,
	fixtureId: null,
	homeTeam: "",
	awayTeam: "",
	homeLogo: "",
	awayLogo: "",
};

const PostBroadcastContext = createContext<PostBroadcastContextValue>(defaultValue);

export const usePostBroadcastContext = () => useContext(PostBroadcastContext);

export const PostBroadcastProvider: FC<{
	value: PostBroadcastContextValue;
	children: ReactNode;
}> = ({ value, children }) => (
	<PostBroadcastContext.Provider value={value}>
		{children}
	</PostBroadcastContext.Provider>
);
